firebird.factory('desktopNotificationService', [
    'helperService',
    '$rootScope',
    '$window',
    'logService',
    'meetingService',
    'brandingService',
    function (helperService, $rootScope, $window, logService, meetingService, brandingService) {
        let isNotificationsDisabled = false;
        const logger = logService.createLoggerWithSource('desktopNotificationService');

        const service = {
            show: show,
            disableNotifications: disableNotifications,
            enableNotifications: enableNotifications
        };

        return service;

        ////////////////////////

        function show(message, type, title, clickCB) {
            if (!canShow()) {
                return;
            }

            //adding date.now to the tag because without it, notification only shows up once
            logger.log('show', 'Before showing notification: ' + message);
            const desktopNotification = new $window.Notification(
                title ? title : meetingService.getCompanyName() + ' Notification',
                {
                    icon: brandingService.getDesktopNotificationIcon(),
                    body: message,
                    tag: type + Date.now(),
                    renotify: true
                }
            );

            desktopNotification.onclick = function () {
                logger.log('desktopNotification.onclick', 'clicked');
                $window.focus();
                if (clickCB) {
                    clickCB();
                } else if (this.tag.indexOf('chat') === 0) {
                    $rootScope.$broadcast('chat-desktop-notification-onclick');
                } else if (this.tag.indexOf('presenter-chat') === 0) {
                    $rootScope.$broadcast('presenter-chat-desktop-notification-onclick');
                } else if (this.tag.indexOf('qanda') === 0) {
                    $rootScope.$broadcast('show-modal', 'webinarPresenterQA', true);
                } else if (this.tag.indexOf('join-request-list') === 0) {
                    $rootScope.$broadcast('join-request-list-desktop-notification-onclick');
                }
                this.close();
            };

            desktopNotification.onerror = function (err) {
                console.log(err);
            };
        }

        function canShow() {
            return (
                helperService.isMobile() === false &&
                helperService.isVideoRoomApplication() === false &&
                helperService.hasNotificationAPIPermission() === true &&
                !isNotificationsDisabled
            );
        }

        //ANYAM-101650 disable notifications before window close in unite due to bug in electron https://github.com/electron/electron/issues/35948
        function disableNotifications() {
            logger.log('disableNotifications', 'Desktop notifications disbaled');
            isNotificationsDisabled = true;
        }

        function enableNotifications() {
            logger.log('enableNotifications', 'Desktop notifications enabled');
            isNotificationsDisabled = false;
        }
    }
]);
